class SearchModal {
    constructor() {
        this.modal = document.getElementById('SearchModal');
        this.input = this.modal?.querySelector('input[name="q"]');
        this.closeButton = this.modal?.querySelector('.search-modal__close-button');

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);

        this.init();
    }

    init() {
        if (!this.modal) return;

        // Header Icon Click (Support both link and button triggers)
        const triggers = document.querySelectorAll('a[href="/search"], [data-search-toggle]');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        });

        // Close Button
        this.closeButton?.addEventListener('click', this.close);

        // Escape Key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen()) {
                this.close();
            }
        });

        // Click outside (Background)
        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.close();
        });
    }

    open() {
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        setTimeout(() => this.input?.focus(), 100);
    }

    close() {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
    }

    isOpen() {
        return this.modal.classList.contains('active');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.searchModal = new SearchModal();
});
